import * as moderationStatus from '../enums/moderation-status'
import arrayUtil from '../utils/array-util'
import * as categories from '../enums/categories'

export default {
  setContent(state, content) {
    state.homeContent = content
  },
  setSearchResults(state, {content, nextPageToken}) {
    state.search.searchResults.items = content
    state.search.searchResults.nextPageToken = nextPageToken
    state.search.searchResults.totalResults = content.length
  },
  setLoadingFlag(state, flag) {
    state.search.searchResults.loading = flag
  },
  setLoadingStrandsFlag(state, flag) {
    state.search.searchResults.loadingStrands = flag
  },
  setErrorStatus(state, error) {
    state.search.searchResults.error.status = error.status
  },
  addDetail(state, detail) {
    state.contentDetails[detail.id] = detail
  },
  updateSearchText(state, searchText) {
    state.search.textInput = searchText
  },
  updateFilters(state, filters) {
    state.search.filters = filters
  },
  updateSorting(state, sorting) {
    state.search.sorting = sorting
  },
  updateSortingItems(state, items) {
    state.search.sorting.items = items
  },
  updatePaginationPage(state, page) {
    state.search.pagination.pageNumber = page
  },
  upsertContentDetail(state, {detail, id}) {
    state.content = {contentId: id, detail}
  },
  updateAuthorFilter(state, author) {
    state.search.authorFilter.author = author
  },
  updateKeywordFilter(state, keyword) {
    state.search.keywordFilter.keyword = keyword
  },
  setDefaultSorting(state, items) {
    state.search.sorting.items = items
  },
  setMobileFiltersVisibility(state, visibility) {
    state.mobileFiltersVisible = visibility
  },
  setCategoryContent(state, {category, content}) {
    switch (category) {
      case categories.MOST_POPULAR_RESOURCES:
        state.categories.mostPopular = content
        break
      case categories.STUDENT_ACTIVITIES:
        state.categories.studentActivities = content
        break
      case categories.MANAGE_YOUR_CLASSROOM:
        state.categories.manageYourClassRoom = content
        break
      case categories.TRY_SOMETHING_NEW:
        state.categories.trySomethingNew = content
        break
      case categories.FEATURED_CONTENT:
        state.categories.featuredContent = content
        break
      case categories.STANDARDS_CONTENT:
        state.categories.standardsContent = content
        break
      case categories.TOP_PRIMARY:
        state.categories.topPrimary = content
        break
      case categories.TOP_SECONDARY:
        state.categories.topSecondary = content
        break
      case categories.FEATURED_PUBLISHER_CONTENT:
        state.categories.featuredPublisherContent = content
        break
    }
  },
  updateSelectedCategory(state, category) {
    state.categories.selectedCategory = category
  },
  updateCallout(state, active) {
    state.callout = active
  },
  setModeratedResources(state, {status, item}) {
    switch (status) {
      case moderationStatus.PENDING.toUpperCase():
        let pendingItems = state.moderation.resources.pending.items
        pendingItems.push(item)
        let sortedPendingItems = arrayUtil.sortArray(pendingItems, 'desc', 'lastModTime')
        state.moderation.resources.pending.items = sortedPendingItems
        break
      case moderationStatus.APPROVED.toUpperCase():
        let approvedItems = state.moderation.resources.approved.items
        approvedItems.push(item)
        let sortedApprovedItems = arrayUtil.sortArray(approvedItems, 'desc', 'lastModTime')
        state.moderation.resources.approved.items = sortedApprovedItems
        break
      case moderationStatus.DECLINED.toUpperCase():
        let declinedItems = state.moderation.resources.declined.items
        declinedItems.push(item)
        let sortedDeclinedItems = arrayUtil.sortArray(declinedItems, 'desc', 'lastModTime')
        state.moderation.resources.declined.items = sortedDeclinedItems
    }
  },
  setModeratedResourcePage(state, {status, page}) {
    switch (status) {
      case moderationStatus.PENDING:
        state.moderation.resources.pending.currentPage = page
        break
      case moderationStatus.APPROVED:
        state.moderation.resources.approved.currentPage = page
        break
      case moderationStatus.DECLINED:
        state.moderation.resources.declined.currentPage = page
    }
  },
  setModeratedResourcesLoadingStatus(state, {status, loading}) {
    switch (status) {
      case moderationStatus.PENDING:
        state.moderation.resources.pending.loading = loading
        break
      case moderationStatus.APPROVED:
        state.moderation.resources.approved.loading = loading
        break
      case moderationStatus.DECLINED:
        state.moderation.resources.declined.loading = loading
    }
  },
  setPendingModerationResourceDefaults(state) {
    state.moderation.resources.pending.items = []
    state.moderation.resources.pending.currentPage = 1
  },
  setApprovedModerationResourceDefaults(state) {
    state.moderation.resources.approved.items = []
    state.moderation.resources.approved.currentPage = 1
  },
  setDeclinedModerationResourceDefaults(state) {
    state.moderation.resources.declined.items = []
    state.moderation.resources.declined.currentPage = 1
  },
  setSelectedModeratedResource(state, status) {
    switch (status) {
      case moderationStatus.PENDING:
        state.moderation.resources.pending.selected = true
        state.moderation.resources.approved.selected = false
        state.moderation.resources.declined.selected = false
        break
      case moderationStatus.SHARED:
        state.moderation.resources.approved.selected = true
        state.moderation.resources.pending.selected = false
        state.moderation.resources.declined.selected = false
        break
      case moderationStatus.DECLINED:
        state.moderation.resources.declined.selected = true
        state.moderation.resources.approved.selected = false
        state.moderation.resources.pending.selected = false
    }
  },
  setResourceDataAdded(state, added) {
    state.moderation.resources.resourceDataAdded = added
  },
  setModerationQueueLoadingStatus(state, {status, loading}) {
    switch (status) {
      case moderationStatus.PENDING:
        state.moderationQueue.pending.loading = loading
        break
      case moderationStatus.DECLINED:
        state.moderationQueue.declined.loading = loading
    }
  },
  setModerationQueue(state, {status, item}) {
    switch (status) {
      case moderationStatus.PENDING.toUpperCase():
        let pendingItems = state.moderationQueue.pending.items
        pendingItems.push(item)
        let sortedPendingItems = arrayUtil.sortArray(pendingItems, 'asc', 'lastModTime')
        state.moderationQueue.pending.items = sortedPendingItems
        break
      case moderationStatus.DECLINED.toUpperCase():
        let declinedItems = state.moderationQueue.declined.items
        declinedItems.push(item)
        let sortedDeclinedItems = arrayUtil.sortArray(declinedItems, 'asc', 'lastModTime')
        state.moderationQueue.declined.items = sortedDeclinedItems
    }
  },
  setSelectedModerationQueue(state, status) {
    switch (status) {
      case moderationStatus.PENDING:
        state.moderationQueue.pending.selected = true
        state.moderationQueue.declined.selected = false
        break
      case moderationStatus.DECLINED:
        state.moderationQueue.pending.selected = false
        state.moderationQueue.declined.selected = true
    }
  },
  setModerationResourcePage(state, {status, page}) {
    switch (status) {
      case moderationStatus.PENDING:
        state.moderationQueue.pending.currentPage = page
        break
      case moderationStatus.DECLINED:
        state.moderationQueue.declined.currentPage = page
    }
  },
  setModerationQueueDefaults(state) {
    state.moderationQueue.pending.items = []
    state.moderationQueue.pending.loading = false
    state.moderationQueue.pending.currentPage = 1
    state.moderationQueue.declined.items = []
    state.moderationQueue.declined.loading = false
    state.moderationQueue.declined.currentPage = 1
  },
  setModerationQueues(state, {list}) {
    let queue = state.moderationQueue.queues.items
    state.moderationQueue.queues.items = queue.concat(list)
  },
  setResourceStatusModeration(state, {contentId, status}) {
    if (status === moderationStatus.DECLINED) {
      let index = state.moderationQueue.pending.items.findIndex(k => k.contentId === contentId)
      let item = state.moderationQueue.pending.items.find(k => k.contentId === contentId)
      state.moderationQueue.pending.items.splice(index, 1)
      item.status = moderationStatus.DECLINED.toUpperCase()
      state.moderationQueue.declined.items.push(item)
    } else {
      let index = state.moderationQueue.pending.items.findIndex(k => k.contentId === contentId)
      state.moderationQueue.pending.items.splice(index, 1)
      let queueIndex = state.moderationQueue.queues.items.findIndex(k => k.contentId === contentId)
      state.moderationQueue.queues.items.splice(queueIndex, 1)
    }
  },
  setModerationQueuesLoadingStatus(state, {loading}) {
    state.moderationQueue.queues.loading = loading
  },
  setModeratedQueuesLoadingStatus(state, {loading}) {
    state.moderationQueue.queues.loading = loading
  },
  setUserModQueues(state, {list}) {
    let queue = state.moderation.resources.queues.items
    state.moderation.resources.queues.items = queue.concat(list)
  },
  setQueuesDefault(state) {
    state.moderation.resources.queues.items = []
  },
  setCountries(state, supportedCountries) {
    state.supportedCountries = supportedCountries
  },
  setLanguages(state, supportedLanguages) {
    state.supportedLanguages = supportedLanguages
  },
  clearFeatures(state) {
    state.feature = {}
  },
  fallbackLocale(state, value) {
    state.locale.fallbackLocale = value
  },
  updateUserLocation(state, location) {
    state.search.userLocation = location
  },
  setLangLoadStatus(state, value) {
    state.langLoadStatus = value
  },
  setLocationFilter(state, {locations, status}) {
    if (status === 'pending') {
      state.moderationQueue.filters.find(x => x.title === 'pending locations').items = locations
    } else {
      state.moderationQueue.filters.find(x => x.title === 'declined locations').items = locations
    }
  },
  setSelectedStandard(state, id) {
    let standards = state.search.filters.find(x => x.title === 'Standards').items
    standards.map((standard) => {
      if (standard.id === id) {
        standard.selected = true
      } else {
        standard.selected = false
      }
    })
    state.search.filters.find(x => x.title === 'Standards').items = standards
  },
  setStrands(state, strands) {
    if (strands === null) {
      state.search.filters.find(x => x.title === 'Strands').items = []
    } else {
      state.search.filters.find(x => x.title === 'Strands').items = strands
    }
  },
  setSelectedStrands(state, guids) {
    let strands = state.search.filters.find(x => x.title === 'Strands').items
    strands.map((strand) => {
      if (guids.includes(strand.guid)) {
        strand.selected = true
      } else {
        strand.selected = false
      }
    })
    state.search.filters.find(x => x.title === 'Strands').items = strands
  },
  setSearchStrands(state, strands) {
    if (strands === null) {
      state.search.searchResults.strands = []
    } else {
      state.search.searchResults.strands = strands
    }
  },
  setSelectedSearchStrands(state, guids) {
    let strands = state.search.searchResults.strands
    strands.map((strand) => {
      if (strand.id === 'none') {
        strand.selected = false
      }
      if (guids.includes(strand.id)) {
        strand.selected = true
      }
    })
    state.search.searchResults.strands = strands
    state.search.filters.find(x => x.title === 'Strands').items = strands
  },
  setDefaultStrands(state) {
    let strands = state.search.searchResults.strands
    strands.map((strand) => {
      if (strand.id === 'none') {
        strand.selected = true
      } else {
        strand.selected = false
      }
    })
    state.search.searchResults.strands = strands
    state.search.filters.find(x => x.title === 'Strands').items = strands
  }
}
